/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TokenPaymentMethod {
    XP = 'XP',
    FIAT = 'FIAT'
}

export function TokenPaymentMethodFromJSON(json: any): TokenPaymentMethod {
    return TokenPaymentMethodFromJSONTyped(json, false);
}

export function TokenPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenPaymentMethod {
    return json as TokenPaymentMethod;
}

export function TokenPaymentMethodToJSON(value?: TokenPaymentMethod | null): any {
    return value as any;
}

